import { c as _c } from "react/compiler-runtime";
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import createFeatureDecisions from '../services/createFeatureDecisions';
export default function useFeatureFlags() {
  const $ = _c(2);
  const {
    currentUser
  } = useCurrentUserContext();
  let t0;
  if ($[0] !== currentUser) {
    t0 = createFeatureDecisions(currentUser);
    $[0] = currentUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const featureDecisions = t0;
  return featureDecisions;
}